import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FilterType } from "../types";

interface FilterParams {
  filter?: string | null;
}

/**
 * Custom hook to manage inbox filter state based on URL parameters
 */
export function useInboxFilters() {
  const [searchParams] = useSearchParams();
  const [activeFilter, setActiveFilter] = useState<FilterType>(FilterType.ALL);

  // Parse URL parameters
  const urlParams: FilterParams = useMemo(
    () => ({
      filter: searchParams.get("filter"),
    }),
    [searchParams],
  );

  // Process URL parameters and update filter state
  useEffect(() => {
    const { filter } = urlParams;
    const validFilters = ["all", "chats", "starred", "archived"];

    if (filter && validFilters.includes(filter)) {
      setActiveFilter(filter as FilterType);
    } else {
      setActiveFilter(FilterType.ALL);
    }
  }, [urlParams]);

  return {
    activeFilter,
    setActiveFilter,
  };
}
